import { render } from "./password.vue?vue&type=template&id=6d6da3b8&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import "./password.vue?vue&type=style&index=0&id=6d6da3b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d6da3b8"

export default script